<template>
  <div class="stockNav">
    <el-submenu index="3">
      <template slot="title">
        <i class="iconfont icon-kucunguanli"></i>
        <span>{{ptitle}}</span>
      </template>
      <el-menu-item
        v-for="(item,i) in menuList"
        :key="i"
        :index="item.index"
        @click="rediret(item)"
      >
        <span slot="title">{{item.title}}</span>
      </el-menu-item>
    </el-submenu>
  </div>
</template>
<script>
export default {
  data () {
    return {
      ptitle: '库存管理',
      menuList: [
        {
          index: '3-1',
          title: '库存管理',
          url: '/stock/manage'
        }
      ]
    }
  },
  created () {
    this.getCurrentIndex(this.$route.path)
  },
  methods: {
    getCurrentIndex (path) {
      if (path.search('stock') !== -1) {
        let selectItem = this.menuList.filter(item => item.url === path)
        this.rediret(selectItem[0])
      }
    },
    rediret (item) {
      this.$emit('rediret', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/layout/leftnav/stockNav.vue